import { CAMERA_FACING_MODE } from '../media/constants';
/**
 * Whether the self view shows mirrored after the camera switch that is about
 * to happen (TOGGLE_CAMERA_FACING_MODE, base/tracks/middleware.any.ts). Only
 * the front (user) camera is mirrored.
 *
 * Robert, 2026-10-13: front, then back, then front again left the self view
 * flipped. react-native-webrtc switches the camera with an asynchronous
 * applyConstraints, so right after `_switchCamera()` the track still reports
 * the side it is leaving, and the mirror was set from that: the back camera
 * mirrored, then the front camera not. This reads the side BEFORE the switch
 * and takes the other one, the same rule react-native-webrtc uses
 * (MediaStreamTrack._switchCamera: 'user' becomes 'environment', anything else
 * becomes 'user').
 *
 * @param {Object} jitsiTrack - The local video JitsiLocalTrack, before the switch.
 * @returns {boolean|undefined} The mirror after the switch, or undefined when
 * this track cannot switch this way (not react-native-webrtc): the caller
 * keeps its old rule.
 */
export function mirrorAfterCameraSwitch(jitsiTrack) {
    const track = jitsiTrack?.track;
    if (!track || typeof track._switchCamera !== 'function') {
        return undefined;
    }
    let facing;
    try {
        facing = track.getSettings?.()?.facingMode;
    }
    catch {
        facing = undefined;
    }
    const next = facing === CAMERA_FACING_MODE.USER ? CAMERA_FACING_MODE.ENVIRONMENT : CAMERA_FACING_MODE.USER;
    return next === CAMERA_FACING_MODE.USER;
}
